<script>
import Base from './Base';

export default {
    extends: Base
};
</script>
